import React, { Fragment } from 'react';
import { FlexRow, Tooltip } from '@contently/toolkit';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { benchmarkTooltipText, benchmarkText } from './benchmarkHelper';

const FlexRowWHeight = styled(FlexRow)`
  margin-top: 0.5rem;
`;

function Benchmark({ percentage, value, type, lastFullMonthName, positive, valueChangeDirection }) {
  const monthlyChangeDirection = valueChangeDirection ? 'Up' : 'Down';
  const pubComparisonColor = positive ? 'green' : 'red';
  const monthlyComparisonColor =  valueChangeDirection ? 'green' : 'red';
  console.log(monthlyComparisonColor)
  const tooltipText = benchmarkTooltipText(type, percentage, value, positive, monthlyComparisonColor, pubComparisonColor, monthlyChangeDirection, lastFullMonthName)
  const text = benchmarkText(type, percentage, value, monthlyComparisonColor, positive, monthlyChangeDirection)

  // handles edge case of 0 value
  if (value > -1 || value) {
    return (
      <Fragment>
        <FlexRowWHeight>
          <Tooltip content={tooltipText} position="bottom">
            <FlexRow>
              {value && (
                text
              )}
            </FlexRow>
          </Tooltip>
        </FlexRowWHeight>
      </Fragment>
    );
  }
  return null;
}

export default Benchmark;

Benchmark.defaultProps = {
  percentage: null,
  value: null,
  valueChangeDirection: null,
  lastFullMonthName: "the last month",
  positive: null,
  type: null
};

Benchmark.propTypes = {
  percentage: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueChangeDirection: PropTypes.bool,
  lastFullMonthName: PropTypes.string,
  positive: PropTypes.bool,
  type: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/benchmark.jsx